import React from 'react';
import { useLocation } from 'react-router';
import { toastService } from 'components/molecules/toast';
import { IntervalFormPage } from 'components/organisms/module-settings/key-events-and-intervals/intervals/interval-form-page';
import { useTranslate } from 'hooks/use-translation';
import { useCreateFieldMutation } from 'queries';

interface Params {
  fieldLabel: string;
  metaData: {
    startKeyEventId: number;
    endKeyEventId: number;
  };
}

export const SaveInterval = ({ title, onClose, objectType }) => {
  const translate = useTranslate();
  const { state } = useLocation<Params>();

  const mutation = useCreateFieldMutation({
    onSuccess: (res) => {
      toastService({
        title: translate('settings.intervals.create.success.title'),
        message: translate('settings.intervals.create.success.message', {
          fieldLabel: res ? res.fieldLabel : '',
        }),
      }).success();
    },
  });

  return (
    <IntervalFormPage
      onClose={onClose}
      title={title}
      objectType={objectType}
      mutation={mutation}
      field={{
        fieldLabel: state?.fieldLabel ?? '',
        description: '',
        metaData: {
          startKeyEventId: state?.metaData?.startKeyEventId,
          endKeyEventId: state?.metaData?.endKeyEventId,
        },
      }}
      isDisabled
    />
  );
};
